import { useEffect, useState } from 'react';
import { getContextualAds } from '../services/api';

export default function ContextualAdSlot({ postId = '', text = '', adType = 'banner' }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getContextualAds({ postId, text, adType })
      .then((data) => {
        if (!cancelled) setAds(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setAds([]);
      });

    return () => {
      cancelled = true;
    };
  }, [postId, text, adType]);

  if (!ads.length) return null;

  const ad = ads[0];

  return (
    <a
      className="ad-banner contextual-ad"
      href={ad.linkUrl}
      target="_blank"
      rel="noopener noreferrer sponsored"
      aria-label={`Contextual advertisement: ${ad.businessName}`}
    >
      <span className="ad-label">AD</span>
      {ad.imageUrl && <img className="ad-image" src={ad.imageUrl} alt={ad.businessName} loading="lazy" />}
      <div className="ad-text">
        <span className="ad-business">{ad.businessName}</span>
        <span className="ad-tagline">{ad.tagline}</span>
      </div>
      <span className="ad-cta">Visit →</span>
    </a>
  );
}
